import Vue from 'vue';
import dayjs from 'dayjs';
import { dateFormat } from './util';

Vue.filter('dateFormat', function (date, type = 'ymdhm') {
  if (date > 0) { return dateFormat(date)[type]; } else { return '-'; }
});

Vue.filter('timeFilter', function(val, format = 'MM/DD HH:mm') {
  return val ? dayjs(val * 1000).format(format) : '--';
});